import React from "react";
import { Layout, Menu } from "antd";
import { socialMenu, footerMenu } from "utils/SignInUpData";
const { Footer } = Layout;

const AntdFooter = () => {
  return (
    <Footer>
      <Menu mode="horizontal" items={footerMenu} />
      <Menu mode="horizontal" className="menu-nav-social" items={socialMenu} />
      <p className="copyright">
        Mitran Pack – Operational Network Ecosystem | Copyright © 2025{" "}
        <a href="#pablo">Aileen Tech</a>
      </p>
    </Footer>
  );
};
export default AntdFooter;
